import { useContext } from "react";
import { ContextViewport } from "../contexts";

const useViewport = () => {
    const { width, height } = useContext(ContextViewport);
    
    return { width, height };
}

export default useViewport;